import _ from "lodash";
import React from 'react';

import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { styles } from "./demoFancyMapStyles.js"
import colors from "./colors.js";


var normalMarker = {
  path: "M-1,0a1,1 0 1,0 2,0a1,1 0 1,0 -2,0",
  fillColor: colors.pinkHighlight,
  fillOpacity: 0.8,
  scale: 5,
  strokeWeight: 0.2,
  strokeColor: colors.grey,
};
var highlightMarker = {
  path: "M-1,0a1,1 0 1,0 2,0a1,1 0 1,0 -2,0",
  fillColor: colors.pinkHighlight,
  fillOpacity: 1,
  scale: 7,
  strokeWeight: 0.5,
  strokeColor: colors.grey
};
var selectedMarker = {
  path: "M-1,0a1,1 0 1,0 2,0a1,1 0 1,0 -2,0",
  fillColor: colors.pinkHighlight,
  fillOpacity: 1,
  scale: 7,
  strokeWeight: 0.5,
  strokeColor: colors.grey
};
export const DEFAULT_ZOOM = 4;
const PAN_DELAY = 500; // This is a guess that works relatively well

export const Map = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyCTPJx5hgSK6yRLNtfi02_0QbXxM3fnKyY&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%`, width: `100%` }} />,
    containerElement: <div style={{ height: `100%`, width: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => {

  const getMapCenter = map => {
    if (!map) return;

    const googleCenter = map.getCenter();
    return {
      lat: googleCenter.lat(),
      lng: googleCenter.lng()
    }
  };

  const onCenterChanged = () => {
    const center = getMapCenter(mapRef);
    if (center) {
      props.handleCenterChange(center);
    }
  }

  const onZoomChanged = () => {
    const zoomLevel = mapRef.getZoom();
    if (zoomLevel !== props.zoomLevel) {
      props.setZoom(zoomLevel);
    }
  }

  let mapRef;
  return (
    <>
      <GoogleMap
        fullscreenControl={false}
        zoom={props.zoom}
        defaultZoom={props.zoom}
        ref={(map) => {
          if (map) {
            if (props.selectedDoctor) {
              const doctorLocation = {
                lat: props.selectedDoctor.location.lat,
                lng: props.selectedDoctor.location.lon,
              }

              if (props.zoom !== 8) {
                props.setLastZoom(props.zoom);
              }

              setTimeout(() => props.setZoom(8), PAN_DELAY)
              map.panTo(doctorLocation);
            } else {
              const center = getMapCenter(map);
              if (!_.isEqual(center, props.center)) {
                props.setZoom(props.lastZoom);
                setTimeout(() => map.panTo(props.center), PAN_DELAY);
              }
            }
          }

          mapRef = map;
        }}
        onCenterChanged={onCenterChanged}
        onZoomChanged={onZoomChanged}
        center={props.center}
        defaultOptions={{
          draggableCursor: 'default',
          draggingCursor: 'move',
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          disableDefaultUI: true,
          gestureHandling: 'cooperative',
          styles
        }}
      >
          {props.doctors.map(d => {
            if (d.location?.lat && d.location?.lon) {
              return (
                <Marker
                  key={d.id}
                  icon={props.selectedDoctor && props.selectedDoctor.id === d.id ? selectedMarker : props.hoverDoctor === d.id ? highlightMarker : normalMarker}
                  position={{lat: d.location.lat, lng: d.location.lon}}
                  onMouseOver={() => {
                    props.onMouseOver(d);
                  }}
                  onMouseOut={() => {
                    props.onMouseOut();
                  }}
                  onClick={() => {
                    props.onClick(d);
                  }}
                />
              )
            }
          })}
      </GoogleMap>
    </>
  )

})
